import { Component, Prop, Vue } from 'vue-property-decorator';
import HearingService from '../../services/HearingService';
import NoteTaskService from '../../services/NoteTaskService';
const Grid = require('../grid/grid.vue.html');
const Attachments = require('../attachments/attachments.vue.html');
import EmailModel from '../../models/EmailModel';
import ButtonModel from '../../models/ButtonModel';

@Component({
    components: {
        Grid,
        Attachments
    }
})
export default class Email extends Vue {
    @Prop({ required: true }) policyNumber!: string;
    @Prop({ required: false, type: Boolean, default: false }) includeSignature!: string;
    @Prop({ type: Object, required: false }) value!: EmailModel;

    pagination: any = { rowsPerPage: 4 };
    contactsData: any = { data: [] };
    display: Boolean = true;
    additionalRecipients: string = '';
    recipients: Array<string> = [];
    submitButton: ButtonModel = { title: 'Send', action: 'submit' }
    subject: string = '';
    body: string = '';
    attachments: Array<any> = [];
    attachmentString: string = '';
    emailError: Boolean = false;
    emailSignature: string = '';
    fromEmail: string = '';

    public service = new HearingService();
    public noteService = new NoteTaskService();

    changeSort(column: string) {
        if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending
        } else {
            this.pagination.sortBy = column
            this.pagination.descending = false
        }
    }

    setCursorPosition(el: FocusEvent) {
        //sets the pointer to the start of the textarea to allow users to more easily tab through the form
        //while typing up email data. Otherwise, if there is an email signature and they tab into the textbox, the cursor goes to the end of the
        //signature line.
        let target: HTMLTextAreaElement = <HTMLTextAreaElement>el.target;
        target.setSelectionRange(0, 0);
    }

    created() {
        if (this.value) {
            this.subject = this.value.subject;
            this.body = this.value.body;
            this.attachments = this.value.attachments;
            if (this.value.recipients) {
                let test: string = this.value.recipients;
                if (test)
                    this.recipients = test.split(';');
            }
            else
                this.recipients = [];
            this.submitButton = this.value.function;
        }

        //only add the signature if it hasn't been added already
        if (this.includeSignature)
            this.noteService.GetUserEmailSignature(this.$store.getters.userName).then(resp => {
                if (resp) {
                    this.emailSignature = '\n\n\n' + resp.signature;
                    this.body += this.emailSignature;
                    this.fromEmail = resp.UserEmailAddress;
                }
            });

        //take the incoming object and map it to the UI
        if (this.policyNumber) {
            this.service.GetCombinedContacts({ policyNumber: this.policyNumber })
                .then((resp => {
                    this.contactsData.data = resp;
                    Vue.set(this.contactsData, 'selected', []);
                    //do this to load data correctly if any passed in as selected contacts
                    this.loadRecipients();
                }));
        }
        else
            console.log('policy number is null and required to load contacts');

        this.$store.dispatch('isLoading', false);
    }

    loadRecipients() {

        if (this.recipients)
            for (var i = 0; i <= this.recipients.length - 1; i++) {
                let emailAddr: string = this.recipients[i];
                if (emailAddr) {
                    let exists = this.contactsData.data.find((obj: any) => obj.eMail == emailAddr);
                    if (exists)
                        this.contactsData.selected.push(emailAddr);
                    else {
                        this.contactsData.data.push({ id: 0, eMail: emailAddr, name: emailAddr });
                        this.contactsData.selected.push(emailAddr);
                    }
                }
            }
    }

    addManualEntry(item: any) {
        let newEmail = item.currentTarget._value;

        if (newEmail) {
            let regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

            this.emailError = !regexp.test(newEmail);

            if (!this.emailError) {
                const index = this.contactsData.selected.indexOf(newEmail);
                if (index == -1) {
                    this.contactsData.data.push({ id: 0, eMail: newEmail, name: newEmail });
                    this.contactsData.selected.push(newEmail);
                }
            }
        }
    }

    remove(item: any) {
        const index = this.contactsData.selected.indexOf(item.eMail)
        if (index >= 0) this.contactsData.selected.splice(index, 1)

        //id of zero indicates it was a manually entered email address, not part of the 
        //data returned from the api and we need to remove it from the original data source
        if (item.id == 0) {
            const dataIdx = this.contactsData.data.indexOf(item);
            if (dataIdx >= 0)
                this.contactsData.data.splice(dataIdx, 1);
        }
    }

    submit() {
        this.$store.dispatch("isLoading", true);

        this.$validator.validate()
            .then((result) => {
                if (result) {
                    if (this.attachments && this.attachments.length > 0) {
                        this.noteService.UploadFiles(this.attachments, this.$store.state.user.userName)
                            .then((response) => {
                                for (var i = 0; i <= response.length - 1; i++) {
                                    this.attachmentString += response[i] + ';';
                                }

                                this.SendEmail();
                            })
                    }
                    else {
                        this.SendEmail();
                    }
                }
                this.$store.dispatch("isLoading", false);
            })
    }

    SendEmail() {
        let emailObj = {
            subject: this.subject,
            message: this.body,
            attachment: this.attachmentString,
            recipients: '',
            emailSignature: this.emailSignature,
            fromEmail: this.fromEmail
        }

        if (this.contactsData.selected)
            for (var i = 0; i <= this.contactsData.selected.length - 1; i++) {
                emailObj.recipients += this.contactsData.selected[i] + ';';
            }

        if (this.additionalRecipients)
            for (var i = 0; i <= this.additionalRecipients.length - 1; i++) {
                emailObj.recipients += this.additionalRecipients[i] + ';';
            }

        this.noteService.SendEmail(emailObj)
            .then((response) => {
                if (response) {
                    this.$store.dispatch('addApplicationMessages', { class: 'success', messages: ["Email queued successfully!"] });
                }
                else {
                    this.$store.dispatch('addApplicationMessages', { class: 'error', messages: ["Something went wrong"] });
                }
                this.$store.dispatch("isLoading", false);
                this.$emit('emailClosed');
            })
            .catch(error => { })
    }

    cancelEmail() {
        this.subject = '';
        this.body = '';
        this.attachments = [];
        this.recipients = [];
        this.emailSignature = '';
        this.additionalRecipients = '';
        this.fromEmail = '';

        let emailObj: EmailModel = {
            subject: this.subject,
            body: this.body,
            attachments: this.attachments,
            recipients: '',
            additionalRecipients: '',
            emailSignature: this.emailSignature,
            fromEmail: this.fromEmail,
            function: this.value.function
        }

        this.$emit('input', emailObj);
        this.$emit('cancelEmail');
    }

    submitEmail() {
        this.$store.dispatch("isLoading", true);

        this.$validator.validate()
            .then((result) => {
                if (result) {
                    let emailObj: EmailModel = {
                        subject: this.subject,
                        body: this.body,
                        attachments: this.attachments,
                        recipients: '',
                        additionalRecipients: '',
                        emailSignature: this.emailSignature,
                        fromEmail: this.fromEmail,
                        function: this.value.function
                    }

                    if (this.contactsData.selected)
                        for (var i = 0; i <= this.contactsData.selected.length - 1; i++) {
                            emailObj.recipients += this.contactsData.selected[i] + ';';
                        }

                    this.$emit('input', emailObj);
                    this.$emit(this.submitButton.action);
                }

                this.$store.dispatch("isLoading", false);
            })
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/components/email/email.ts